import { useState } from 'react';
import { FiX, FiSend, FiMessageSquare } from 'react-icons/fi';
import { supabase } from '../../lib/supabase';

const ChatModal = ({ onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      if (supabase) {
        const { error: dbError } = await supabase.from('chat_messages').insert({
          name: name.trim(),
          email: email.trim(),
          message: message.trim(),
        });
        if (dbError) throw dbError;
      }
      setSent(true);
    } catch (err) {
      setError('Could not send message. Please try emailing us directly at trelledex@gmail.com');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="chat-modal-overlay" onClick={onClose}>
      <div className="chat-modal" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <div className="chat-modal-header">
          <div className="chat-modal-title">
            <FiMessageSquare size={20} />
            <span>Chat with Trelledex</span>
          </div>
          <button className="chat-modal-close" onClick={onClose} aria-label="Close">
            <FiX size={18} />
          </button>
        </div>

        {sent ? (
          <div className="chat-modal-body chat-success">
            <div className="chat-success-icon">✓</div>
            <h3>Message received!</h3>
            <p>Thanks for reaching out. Our team will respond to <strong>{email}</strong> within one business day.</p>
            <button className="btn btn-primary" onClick={onClose}>Close</button>
          </div>
        ) : (
          <div className="chat-modal-body">
            <p className="chat-modal-intro">Have a question or want to learn more? Send us a message and we'll get back to you quickly.</p>

            {error && <div className="auth-error-box">{error}</div>}

            <form onSubmit={handleSubmit} className="chat-form">
              <label className="form-field">
                <span>Your Name</span>
                <input className="input" type="text" placeholder="Jane Doe"
                  value={name} onChange={e => setName(e.target.value)} required />
              </label>
              <label className="form-field">
                <span>Email Address</span>
                <input className="input" type="email" placeholder="jane@company.com"
                  value={email} onChange={e => setEmail(e.target.value)} required />
              </label>
              <label className="form-field">
                <span>Message</span>
                <textarea className="input textarea" rows={4}
                  placeholder="Tell us what you need or ask us anything…"
                  value={message} onChange={e => setMessage(e.target.value)} required />
              </label>
              <button className="btn btn-primary btn-full" type="submit" disabled={sending}>
                {sending ? 'Sending…' : 'Send Message'} {!sending && <FiSend size={14} />}
              </button>
            </form>

            <div className="chat-modal-footer">
              <span>Or email us directly: <a href="mailto:trelledex@gmail.com">trelledex@gmail.com</a></span>
              <span>Call: <a href="tel:+27677528778">+27 67 752 8778</a></span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatModal;
